import { render, staticRenderFns } from "./MobileGame.vue?vue&type=template&id=b4f05334&scoped=true&"
import script from "./MobileGame.vue?vue&type=script&lang=js&"
export * from "./MobileGame.vue?vue&type=script&lang=js&"
import style0 from "./MobileGame.vue?vue&type=style&index=0&id=b4f05334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f05334",
  null
  
)

export default component.exports